import React from 'react'

import {
  ILayout_Render,
  ILayout_Cell_Props_HTML,
} from '../types/layout'

const HTMLComponent: ILayout_Render<ILayout_Cell_Props_HTML> = ({
  cell,
}) => {
  const {
    html,
  } = cell.data
  
  return (
    <div dangerouslySetInnerHTML={{__html: html}}>
      
    </div>
  )
}

export default HTMLComponent 